import { getToken } from '@/systems/Authentication'

export const API_URL = import.meta.env.DEV ? "http://127.0.0.1:5003/sapientclinician/us-central1" : "https://io.sapientclinician.com";

function logLoaderError(error) {
  const expectedAuthErrors = ["No user", "Incomplete userdata"];
  if (expectedAuthErrors.includes(error?.message)) {
    console.info(error);
    return;
  }
  console.error(error);
}

export function publicAction(intent, data, { dontWait = false, allowIncompleteUserdata = false, educatorOnly = false, unauthenticated = false, signal = null, download_file = false } = {}) {
  return new Promise(function(resolve, reject) {
    if (unauthenticated) {
      doFetch(null);
    } else {
      getToken({ dontWait, allowIncompleteUserdata, educatorOnly: (educatorOnly ? true : false) }).then(function(token) {
        doFetch(token);
      }).catch(function(error) {
        if (error.message == "Educator only" && educatorOnly) {
          resolve(educatorOnly);
        } else {
          logLoaderError(error);
          reject(error);
        }
      });
    }

    function doFetch(token) {
      fetch(API_URL+"/publicAction", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          intent: intent,
          data: data,
          token: token
        }),
        signal: signal
      }).then(function(response) {
        if (response.ok) {
          if (download_file) {
            const disposition = response.headers.get('Content-Disposition');
            const match = disposition?.match(/filename="?([^";\n]+)"?/);
            const serverFilename = match ? match[1] : "download";

            response.blob().then(function(blob) {
              const url = URL.createObjectURL(blob);
              const a = document.createElement('a');
              a.href = url;
              a.download = serverFilename;
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              URL.revokeObjectURL(url);
              resolve();
            }).catch(function(error) {
              console.error(error);
              reject(error);
            });
          } else {
            response.json().then(function(data) {
              resolve({data: data});
            }).catch(function(error) {
              console.error(error);
              reject(error);
            });
          }
        } else {
          console.error("Bad response: ", response.status);
          const error = new Error("Failed to load");
          error.status = response.status;
          reject(error);
        }
      }).catch(function(error) {
        if (error.name === 'AbortError') {
          reject(error);
        } else {
          console.error(error);
          reject(error);
        }
      })
    }
  })
}

export function internalAction(intent, data, { signal = null } = {}) {
  return new Promise(function(resolve, reject) {
    getToken({}).then(function(token) {
      fetch(API_URL+"/internalAction", {
        method: "post",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          intent: intent,
          data: data,
          token: token
        }),
        signal: signal
      }).then(function(response) {
        if (response.ok) {
          response.json().then(function(data) {
            resolve({data: data});
          }).catch(function(error) {
            console.error(error);
            reject(error);
          });
        } else {
          console.error("Bad response: ", response.status);
          const error = new Error("Failed to load");
          error.status = response.status;
          reject(error);
        }
      }).catch(function(error) {
        if (error.name === 'AbortError') {
          reject(error);
        } else {
          console.error(error);
          reject(error);
        }
      })
    }).catch(function(error) {
      logLoaderError(error);
      reject(error);
    });
  })
}